// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductLayout_wrapper__hPcbv","filter":"ProductLayout_filter__Rb-Sf","content":"ProductLayout_content__FJUxg"};